/**
 * 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" style="width:140px" placeholder="输入用户名" c></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:140px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.province" style="width:140px" placeholder="输入号码归属地"></el-input>
      </el-form-item>
       <el-form-item label="是否商务：">
        <el-select size="small" v-model="formInline.is_seller" style="width:100px" placeholder="请选择">
          <el-option v-for="type in seller" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" style="width:180px" value-format="yyyy-MM-dd" placeholder="选择注册开始时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" style="width:180px" value-format="yyyy-MM-dd" placeholder="选择注册结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleExport" title="批量导入用户">用户导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="sendAll" title="批量发送通知消息">发送消息</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="uid" v-if="idShow">
      </el-table-column>
      <el-table-column prop="username" align="center" label="用户名" width="100px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pc_mobile" align="center" label="联系方式" width="100px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="attribution" align="center" label="号码归属地" width="120px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="invite_name" align="center" label="邀请人" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="account_name" align="center" label="账户类型" width="90" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="is_seller_name" align="center" label="是否商务" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="remind_config_name" align="center" label="是否提醒" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="auth" align="center" label="权限" width="60" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sign" align="center" label="所属" width="60" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="integral" align="center" label="积分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="account_level" align="center" label="VIP" :formatter="accountLevel"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="account_time" align="center" label="到期时间" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="last_login_time" align="center" label="上次登录时间" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="reg_time" align="center" label="注册时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="360px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleIntegral(scope.$index, scope.row)" title="积分充值">充值</el-button>
          <el-button size="mini" @click="handleSeller(scope.$index, scope.row)" title="将账户设置为商务">商务</el-button>
          <el-button size="mini" @click="handleRemind(scope.$index, scope.row)" title="设置消息提醒">消息</el-button>
          <el-button size="mini" @click="handleVip(scope.$index, scope.row)" title="VIP设置">VIP</el-button>
          <el-button type="success" size="mini" @click="handleAuth(scope.$index, scope.row)" title="设置权限">权限</el-button>
          <!-- <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">提醒</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户昵称">
              <el-input size="small" v-model="infoForm.username" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.pc_mobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="号码归属地">
              <el-input size="small" v-model="infoForm.attribution" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="注册时间">
              <el-input size="small" v-model="infoForm.reg_time" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">  
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 消息发送界面(单发) -->
    <el-dialog :title="sendTitle" :visible.sync="sendFormVisible" width="50%" @click="closeDialog('sendForm')">
      <el-form label-width="120px" ref="sendForm" :model="sendForm" :rules="sendFormRules">
        <el-row>
            <el-form-item label="通知标题" prop="title">
              <el-input size="small" v-model="sendForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="通知内容" prop="content">
              <el-input size="small" type="textarea" v-model="sendForm.content" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitSend('sendForm')">发布</el-button>
              <el-button size="mini" @click='closeDialog("sendForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 消息发送界面(群发) -->
    <el-dialog :title="sendTitle" :visible.sync="sendCheckFormVisible" width="50%" @click="closeDialog('sendCheckForm')">
      <el-form label-width="120px" ref="sendCheckForm" :model="sendCheckForm" :rules="sendCheckFormRules">
        <el-row>
            <el-form-item label="通知标题" prop="title">
              <el-input size="small" v-model="sendCheckForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="通知内容" prop="content">
              <el-input size="small" type="textarea" v-model="sendCheckForm.content" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitCheckSend('sendCheckForm')">发布</el-button>
              <el-button size="mini" @click='closeDialog("sendCheckForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

     <!-- 上传Excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M<button @click="downloadExcel()" style="margin-left: 15px;cursor: pointer">下载模板</button></div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 商务设置界面 -->
    <el-dialog :title="title" :visible.sync="sellerCheckFormVisible" width="50%" @click="closeDialog('sellerCheckForm')">
      <el-form label-width="120px" ref="sellerCheckForm" :model="sellerCheckForm">
        <el-row>
            <el-form-item label="是否商务" prop="is_seller">
                <el-radio-group type="kind" v-model="sellerCheckForm.is_seller"> 
                    <el-radio v-model="sellerCheckForm.is_seller" :label="1">否</el-radio>
                    <el-radio v-model="sellerCheckForm.is_seller" :label="2">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitSeller('sellerCheckForm')">确定</el-button>
              <el-button size="mini" @click='closeDialog("sellerCheckForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 提醒设置界面 -->
    <el-dialog :title="title" :visible.sync="remindCheckFormVisible" width="50%" @click="closeDialog('remindCheckForm')">
      <el-form label-width="120px" ref="remindCheckForm" :model="remindCheckForm">
        <el-row>
            <el-form-item label="是否提醒" prop="remind_config">
                <el-radio-group type="kind" v-model="remindCheckForm.remind_config"> 
                    <el-radio v-model="remindCheckForm.remind_config" :label="1">否</el-radio>
                    <el-radio v-model="remindCheckForm.remind_config" :label="2">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitRemind('remindCheckForm')">确定</el-button>
              <el-button size="mini" @click='closeDialog("remindCheckForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- VIP设置界面 -->
    <el-dialog :title="title" :visible.sync="vipCheckFormVisible" width="50%" @click="closeDialog('vipCheckForm')">
      <el-form label-width="120px" ref="vipCheckForm" :model="vipCheckForm">
        <el-row>
            <el-form-item label="VIP等级">
              <el-select size="small" v-model="vipCheckForm.account_level" style="width:300px" placeholder="请选择">
                <el-option v-for="item in vipLevel" :label="item.name" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="到期时间" prop="account_time">
              <el-input size="small" type="text" v-model="vipCheckForm.account_time" auto-complete="off" placeholder="格式:2026-05-26" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="setAccountVip()">提交</el-button>
              <el-button size="mini" @click='closeDialog("vipCheckForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 积分充值界面 -->
    <el-dialog :title="title" :visible.sync="integralFormVisible" width="40%" @click="closeDialog('integralForm')">
      <el-form label-width="120px" :model="integralForm" ref="integralForm">
          <el-form-item label="充值数值">
            <el-input size="small" v-model="integralForm.integral" auto-complete="off" placeholder="请输入纯数字"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="submitRecharge()">充值</el-button>
            <el-button size="mini" @click='closeDialog("integralForm")'>取消</el-button>
          </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 权限设置界面 -->
    <el-dialog :title="title" :visible.sync="authFormVisible" width="30%" @click="closeDialog('authForm')">
      <el-form label-width="120px" :model="authForm" ref="authForm">
        <el-form-item label="权限">
            <!-- <el-input size="small" v-model="authForm.auth" auto-complete="off" placeholder="请输入所属"></el-input> -->
            <el-select size="small" v-model="authForm.auth" style="width:300px" placeholder="请选择" @change="changeUserAuth">
              <el-option v-for="auth in authData" :label="auth.key" :value="auth.value" :key="auth.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上级" v-if="authForm.auth == 'user'">
            <!-- <el-input size="small" v-model="authForm.sign" auto-complete="off" placeholder="请输入所属" style="width: 300px;" clearable></el-input> -->
            <el-select size="small" v-model="authForm.pid" style="width:300px" placeholder="请选择">
              <el-option v-for="auth in parentData" :label="auth.key" :value="auth.value" :key="auth.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="submitAuth()">提交</el-button>
            <el-button size="mini" @click='closeDialog("authForm")'>取消</el-button>
          </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { 
  webUserList,
  webSendUser, 
  webSendUserCheck,
  webUrl, 
  webSetUserSeller, 
  webDownloadUserExcel, 
  webUserInviteList,
  rechargeIntegral,
  webSetUserRemind,
  setUserAuth,
  getAdminData,
  setUserVip 
} from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      sendFormVisible: false, //控制发送消息(单发)页面显示与隐藏
      excelFormVisible: false, //控制批量导入页面显示与隐藏
      sendCheckFormVisible: false, //控制发送消息(群发)页面显示与隐藏
      sellerCheckFormVisible: false, //控制商务设置页面显示与隐藏
      remindCheckFormVisible: false, //控制提醒设置页面显示预隐藏
      vipCheckFormVisible: false, //控制VIP设置页面显示预隐藏
      billFormVisible: false, //控制发票上传界面显示与隐藏
      integralFormVisible: false, //控制积分充值界面显示与隐藏
      authFormVisible: false, //控制权限界面显示与隐藏
      title: '用户详情',
      sendTitle: '',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      infoForm: {
        id: '',
        mobile: '',
        name: '',
        reg_time: '',
        address: '',
        head: '',
        token: localStorage.getItem('logintoken')
      },
      integralForm: {
        uid: '',
        integral: ''
      },
      authForm: {
        auth: '',
        uid: '',
        sign: '',
        pid: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        name: '',
        mobile: '',
        is_seller: 0,
        province: ''
        // token: localStorage.getItem('logintoken')
      },
      sendForm: {
        uid: '',
        title: '',
        content: ''
      },
      // integralForm: {
      //   uid: 0,
      //   integral: 0,
      //   mobile: '',
      //   name: '',
      //   add_integral: 0,
      //   content: ''
      // },
      seller: [
        { key: '全部', value: 0 },
        { key: '是', value: 2 },
        { key: '否', value: 1 }
      ],
      authData: [
        { key: '请选择', value: '' },
        { key: '超级管理员', value: 'super' },
        { key: '推广管理员', value: 'admin' },
        { key: '产品推广员', value: 'user' },
      ],
      // 上级管理员数据
      parentData: [],
      sendCheckForm: {
        ids: '',
        title: '',
        content: ''
      },
      sellerCheckForm: {
        user_id : 0,
        is_seller: 1
      },
      remindCheckForm: {
        user_id: 0,
        remind_config: 2
      },
      vipCheckForm: {
        uid: '',
        account_level: '',
        account_time: ''
      },
      vipLevel: [
        {name: 'VIP 0',value: 1},
        {name: 'VIP 1',value: 2},
        {name: 'VIP 2',value: 3},
        {name: 'VIP 3',value: 4},
        {name: 'VIP 4',value: 5},
        {name: 'VIP 5',value: 6},
      ],
      // 发票数据模型
      billForm: {
        bill_url: '',
        uid: ''
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/users/importUserExcel',

      userparm: [], //搜索权限
      listData: [], //用户数据
      logData: [], //推广记录数据
      invite_num: 0,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      sendFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '200个字符以内', trigger: 'blur' },
        ]
      },
      sendCheckFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 200, message: '200个字符以内', trigger: 'blur' },
        ]
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 格式化用户等级
    accountLevel(row,column){
      let level = 'VIP '+(row.account_level - 1)
      return level;
    },
    // 提交VIP设置
    setAccountVip(){
      setUserVip(this.vipCheckForm)
      .then(res=>{
        if(res.code == 200){
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.vipCheckFormVisible = false
          this.getdata(this.formInline)
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    handleBillSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.billForm.bill_url = response.data.url
          console.log(response)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }
    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },

     //发票上传前的校验
    beforeAvatarBillUpload(file) {
      const that = this
      //  if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
      //     that.$message({
      //         type: 'error',
      //         message: '上传文件只能为excel文件，且为xlsx,xls格式!'
      //     })
      //     return false
      //   }
    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/users/importUserExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webUserList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1,
      this.formInline.ps = 10,
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.uid)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
    //添加提示框，确定后再导出，防止乱点，减轻服务器压力
    this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr)
          window.location.href = webUrl + "/admin/patent/exportUserExcel?ids=" + idStr
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          window.location.href = webUrl + "/admin/patent/exportUserAllExcel?name="+this.formInline.name+"&mobile="+this.formInline.mobile+"&start_time="+
          this.formInline.start_time+"&end_time="+this.formInline.end_time+"&is_seller="+this.formInline.is_seller+"&province="+this.formInline.province;
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    sendAll() {
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.uid)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      this.sendCheckFormVisible = true
      this.sendCheckForm.ids = JSON.stringify(idsArr)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 性别
    wxsexFormat(row,column){
      if(row.wx_qrcode_sex){
        if(row.wx_qrcode_sex == 1){
                  return '男'
              }else if(row.wx_qrcode_sex == 2){
                  return '女'
              }else{
                return '保密'
              }
      }else{
        return ''
      }
    },
     qqsexFormat(row,column){
      if(row.qq_sex){
        if(row.qq_sex == 1){
                  return '男'
              }else if(row.qq_sex == 2){
                  return '女'
              }else{
                return '保密'
              }
      }else{
        return ''
      }
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.title = '积分充值'
      this.editFormVisible = true
      this.infoForm = row
      console.log(row)
      // 查询用户推广记录
      // webUserInviteList({'uid':row.uid})
      //   .then(res => {
      //     res = checkLogin(res)
      //     if (res.code == 200) {
      //         console.log(res)
      //         this.logData = res.data.list
      //         this.invite_num = res.data.num
      //     } else {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('登陆已过期,请重新登陆!')
      //   })

    },
    // 显示积分充值界面
    handleIntegral: function(index, row) {
      this.title = '积分充值'
      this.integralForm.uid = row.uid
      this.integralForm.integral = ''
      this.integralFormVisible = true
    },
    //显示商务设置界面
    handleSeller: function(index,row) {
      this.title = '商务设置'
      this.sellerCheckForm.is_seller = row.is_seller
      this.sellerCheckFormVisible = true
      this.sellerCheckForm.user_id = row.uid
    },
    //显示商务设置界面
    handleRemind: function(index,row) {
      this.title = '提醒设置'
      this.remindCheckForm.remind_config = row.remind_config
      this.remindCheckFormVisible = true
      this.remindCheckForm.user_id = row.uid
    },
    // 显示账户VIP设置
    handleVip(index,row){
      this.title = 'VIP设置'
      console.log(row)
      this.vipCheckForm.uid = row.uid
      this.vipCheckForm.account_level = row.account_level
      this.vipCheckForm.account_time = row.account_time
      this.vipCheckFormVisible = true
    },
    //显示权限设置界面
    handleAuth: function(index,row) {
      this.title = '权限设置'
      this.authForm.auth = row.auth
      this.authForm.uid = row.uid
      this.authFormVisible = true
    },
    // 显示Excel导入页面
    handleExport: function(){
      this.title = '批量导入Excel'
      this.excelFormVisible = true
    },
    submitSend(sendData){
    // 校验参数
      this.$refs[sendData].validate(valid => {
        if(valid){
          // 提交通知
          const sendParam = this.sendForm
          webSendUser(sendParam)
            .then(res => {        
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.sendFormVisible = false
                this.sendForm.id = ''
                this.sendForm.title = ''
                this.sendForm.content = ''
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('登陆已过期,请重新登陆!')
            })
        }else{
          return false;
        }
      })
    },
    submitCheckSend(sendCheckData) {
 // 校验参数
      this.$refs[sendCheckData].validate(valid => {
        if(valid){
          // 提交通知
          const sendParam = this.sendCheckForm
          webSendUserCheck(sendParam)
            .then(res => {        
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.sendCheckFormVisible = false
                this.sendCheckForm.ids = ''
                this.sendCheckForm.title = ''
                this.sendCheckForm.content = ''
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('登陆已过期,请重新登陆!')
            })
        }else{
          return false;
        }
      })
    },
    submitRecharge() {
      // 校验参数
      let param = this.integralForm
      let regex = /^[0-9]*$/
      if(!regex.test(param.integral)){
        this.$message({
          type: 'info',
          message: '请输入正确的数值!'
        })
        return false;
      }
      rechargeIntegral(param)
      .then(res=>{
        res = checkLogin(res)
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.integralFormVisible = false
          this.getdata(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 提交商务设置
    submitSeller(sellerCheckForm) {
      console.log(this.sellerCheckForm)
        webSetUserSeller(this.sellerCheckForm)
            .then(res => {        
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.sellerCheckFormVisible = false
                this.sellerCheckForm.user_id = ''
                this.sellerCheckForm.is_seller = 1
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('登陆已过期,请重新登陆!')
            })
    },
    // 提交提醒设置
    submitRemind(remindCheckForm) {
      console.log(this.remindCheckForm)
        webSetUserRemind(this.remindCheckForm)
            .then(res => {        
              res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.remindCheckFormVisible = false
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('登陆已过期,请重新登陆!')
            })
    },
    submitAuth() {
      let param = this.authForm
      if(param.auth <= 0){
        this.$message({
          type: 'info',
          message: '权限不能为空'
        })
        return false;
      }
    setUserAuth(param)
        .then(res => {        
          res = checkLogin(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.authFormVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('登陆已过期,请重新登陆!')
        })
      console.log(param)
    },
    // 删除监控记录
    delMonitor(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
     // 显示发送消息界面
    send(index, row) {
      console.log(row)
      this.sendFormVisible = true
      this.sendForm.uid = row.uid
      this.sendTitle = '发送通知'
      console.log(this.sendForm)
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'editForm'){
        this.editFormVisible = false
      }else if(formName == 'sendForm'){
        this.sendFormVisible = false
      }else if(formName == 'sendCheckForm'){
        this.sendCheckFormVisible = false
      }else if(formName == 'sellerCheckForm'){
        this.sellerCheckFormVisible = false
      }else if(formName == 'billForm'){
        this.billFormVisible = false
      }else if(formName == 'integralForm'){
        this.integralFormVisible = false
      }else if(formName == 'remindCheckForm'){
        this.remindCheckFormVisible = false
      }else if(formName == 'authForm'){
        this.authFormVisible = false
      }else if(formName == 'vipCheckForm'){
        this.vipCheckFormVisible = false
      }
        this.$refs[formName].resetFields()
    },
    // 下载用户导入excel模板
    downloadExcel(){
      webDownloadUserExcel()
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '模板下载成功!'
              })
              window.location.href = res.data.value
          } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 提交发票
    commitTicket() {
      let uid = this.billForm.uid
      let bill_url = this.billForm.bill_url
      if(bill_url.length <= 0){
        this.$message({
          type: 'info',
          message: '发票必须上传!'
        })
        return false;
      }
      let param = {
        uid: uid,
        bill_url: bill_url
      }
      console.log(param)
    },
    // 账户权限改变
    changeUserAuth(val) {
      if(val == 'user'){
        let param = []
        getAdminData(param)
        .then(res=>{
          if(res.code==200){
            this.parentData = res.data
          }
        })
      }else{
        this.parentData = []
        this.authForm.pid = ''
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.invite_item {
  height: 600px;
  overflow-y: auto;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/user/user.vue